import cx from 'classix';
import { useTranslations } from 'next-intl';
import {
  FaCircleCheck,
  FaUser,
} from 'react-icons/fa6';
import {
  LiaMarsSolid,
  LiaVenusSolid,
} from 'react-icons/lia';

import { type ListingDataView } from '@/features/listing/types/listing-types';
import { VerificationStatus } from '@/features/user/types/user-id-verification-types';
import {
  GENDERS_KEYS,
  type User,
} from '@/features/user/types/user-types';
import Avatar from '@/ui/avatar/avatar';

import styles from './listing-user.module.scss';

interface ListingUserProps {
  user: User;
  view?: ListingDataView;
  isNotActive?: boolean;
  avatarSize?: number;
}

export default function ListingUser(props: ListingUserProps) {
  const {
    avatarSize = 40,
    isNotActive = false,
    user,
    view = 'isCard',
  } = props;

  const {
    age,
    avatar,
    firstName,
    gender,
    verifications,
  } = user;

  const translationsVerifications = useTranslations('global.verifications');

  return (
    <div
      className={cx(
        styles.listingUser,
        view === 'isDetailed' && styles.listingUser__isDetailed,
        view === 'isUserListings' && styles.listingUser__isUserListings,
        isNotActive && styles.listingUser__isNotActive,
      )}
    >
      <Avatar
        imageSrc={avatar.pathSmall}
        alt={firstName}
        size={view === 'isUserListings' ? 80 : avatarSize}
        view={view === 'isUserListings' ? 'square' : 'circle'}
      />

      {view === 'isCard' && (
        <p className={styles.listingUser__info}>
          {firstName}
          ,
          &nbsp;
          {age}
        </p>
      )}

      {view === 'isUserListings' && (
        <div>
          <div className={styles.listingUser_details}>
            <p className={styles.listingUser__info}>
              {firstName}
              ,
              &nbsp;
              {age}
            </p>

            {gender && (
              <div className={styles.listingUser__gender}>
                {gender === GENDERS_KEYS.Female && (
                  <LiaVenusSolid name="female" strokeWidth={1.3} />
                )}

                {gender === GENDERS_KEYS.Male && (
                  <LiaMarsSolid name="male" strokeWidth={1.3} />
                )}
              </div>
            )}
          </div>

          {verifications.id?.status === VerificationStatus.Passed && (
            <div className={styles.listingUser_verified}>
              <div className={styles.listingUser_status}>
                <FaCircleCheck className={styles.listingUser_checked} />
                <FaUser className={styles.listingUser_icon} />
              </div>

              <p className={styles.listingUser_text}>
                {translationsVerifications('id-checked')}
              </p>
            </div>
          )}
        </div>
      )}

      {view === 'isCard' && gender && (
        <div className={styles.listingUser__gender}>
          {gender === GENDERS_KEYS.Female && (
            <LiaVenusSolid name="female" strokeWidth={1.3} />
          )}

          {gender === GENDERS_KEYS.Male && (
            <LiaMarsSolid name="male" strokeWidth={1.3} />
          )}
        </div>
      )}
    </div>
  );
}
